import { useEffect, useState } from 'react';
import { playHaptic } from '../haptics';
import { LOGOS, shuffle } from '../logos';
import { addBalance, formatBalance } from '../balance';
import { playCue } from '../cuelume';
import { GameHeader, ResultActions, ResultSticker } from '../components/GameHeader';

const METRICS = [
  { id: 'marketCap', label: 'Капитализация', unit: 'млрд $' },
  { id: 'employees', label: 'Сотрудники', unit: '' },
];

function pickPair(excludeIds = []) {
  const pool = LOGOS.filter((item) => !excludeIds.includes(item.id));
  const [left, right] = shuffle(pool.length >= 2 ? pool : LOGOS).slice(0, 2);
  const metric = METRICS[Math.floor(Math.random() * METRICS.length)];
  return { left, right, metric };
}

function formatMetric(company, metric) {
  const value = company[metric.id];
  if (metric.id === 'marketCap') return `${formatBalance(value)} ${metric.unit}`;
  return formatBalance(value);
}

function HigherGame({ onExit }) {
  const [{ left, right, metric }, setPair] = useState(pickPair);
  const [revealed, setRevealed] = useState(false);
  const [streak, setStreak] = useState(0);
  const [best, setBest] = useState(0);
  const [finished, setFinished] = useState(false);
  const [wasCorrect, setWasCorrect] = useState(null);

  useEffect(() => {
    if (finished && streak > 0) addBalance(streak * 50);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finished]);

  const restart = () => {
    setPair(pickPair());
    setRevealed(false);
    setStreak(0);
    setFinished(false);
    setWasCorrect(null);
    playHaptic('selection');
  };

  const guess = (higher) => {
    if (revealed || finished) return;
    const leftValue = left[metric.id];
    const rightValue = right[metric.id];
    const rightIsHigher = rightValue > leftValue;
    const correct = higher === rightIsHigher || leftValue === rightValue;
    setRevealed(true);
    setWasCorrect(correct);
    playHaptic(correct ? 'success' : 'error');
    playCue(correct ? 'success' : 'error');

    if (correct) {
      const nextStreak = streak + 1;
      setStreak(nextStreak);
      setBest((b) => Math.max(b, nextStreak));
      setTimeout(() => {
        setPair(pickPair([left.id]));
        setRevealed(false);
        setWasCorrect(null);
        playCue('page');
      }, 900);
    } else {
      setTimeout(() => setFinished(true), 900);
    }
  };

  return (
    <div className="app hl-screen">
      <GameHeader title="Больше?" icon="icon-transfer.svg" onExit={onExit} />

      <div className="score-panel">
        <div className="score-cell">
          <span className="score-value">{streak}</span>
          <span className="score-caption">Серия</span>
        </div>
        <span className="score-divider" aria-hidden="true" />
        <div className="score-cell">
          <span className="score-value">{best}</span>
          <span className="score-caption">Рекорд</span>
        </div>
      </div>

      <div className="hl-question">
        <span className="hl-metric">{metric.label}</span>
        <p>
          У {right.ticker} больше,
          <br />
          чем у {left.ticker}?
        </p>
      </div>

      <main className="hl-board">
        <div className="hl-card">
          <img src={left.src} alt="" draggable="false" />
          <p className="hl-ticker">{left.ticker}</p>
          <p className="hl-name">{left.name}</p>
          <p className="hl-value">{formatMetric(left, metric)}</p>
        </div>

        <p className="hl-vs">VS</p>

        <div className={`hl-card${revealed ? (wasCorrect ? ' good' : ' bad') : ''}`}>
          <img src={right.src} alt="" draggable="false" />
          <p className="hl-ticker">{right.ticker}</p>
          <p className="hl-name">{right.name}</p>
          <p className={`hl-value${revealed ? '' : ' hidden'}`}>
            {revealed ? formatMetric(right, metric) : '???'}
          </p>
        </div>
      </main>

      <div className="hl-actions">
        <button
          type="button"
          className="hl-btn up"
          disabled={revealed || finished}
          onClick={() => guess(true)}
        >
          Больше
        </button>
        <button
          type="button"
          className="hl-btn down"
          disabled={revealed || finished}
          onClick={() => guess(false)}
        >
          Меньше
        </button>
      </div>

      {finished && (
        <div className="result" role="dialog" aria-label="Результат игры">
          <div className={`result-card${streak === 0 ? ' lost' : ''}`}>
            <ResultSticker won={streak > 0} />
            <p className="result-title">Серия оборвалась</p>
            <p className="result-score">{streak * 50}</p>
            <p className="result-score-label">очков за {streak} верных</p>
            <ResultActions onRestart={restart} onHome={onExit} />
          </div>
        </div>
      )}
    </div>
  );
}

export default HigherGame;
